<template>
  <svg
    class="inv-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    v-html="markup"
  ></svg>
</template>

<script>
// Central inline-SVG icon set for the Invest page — stroke-based, matching the
// Exchange (ExIcon) and Wallet icon style. No external icon font.
const ICONS = {
  savings:
    '<path d="M19 10c1.1 0 2 .9 2 2s-.9 2-2 2v3a1 1 0 01-1 1h-2v-2H9v2H7a1 1 0 01-1-1v-2.1A6 6 0 0110 4h4l3-2v3.3A6 6 0 0119 10z"/><circle cx="9" cy="10" r="1"/>',
  "chart-line":
    '<path d="M3 3v18h18"/><path d="M7 14l3-4 3 3 5-6"/>',
  pie:
    '<path d="M21 15.5A9 9 0 118.5 3v9H21z"/><path d="M14 3.5A9 9 0 0120.5 10H14z"/>',
  chevron: '<path d="M6 9l6 6 6-6"/>',
  "chevron-right": '<path d="M9 6l6 6-6 6"/>',
  check: '<path d="M20 6L9 17l-5-5"/>',
  wallet:
    '<path d="M3 7a2 2 0 012-2h13a1 1 0 011 1v2"/><path d="M3 7v10a2 2 0 002 2h14a1 1 0 001-1v-3"/><path d="M21 10h-5a2 2 0 000 4h5z"/>',
  event:
    '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 9h18"/><path d="M8 3v4"/><path d="M16 3v4"/>',
  receipt:
    '<path d="M5 3v18l2-1.5L9 21l2-1.5L13 21l2-1.5L17 21l2-1.5V3l-2 1.5L15 3l-2 1.5L11 3 9 4.5 7 3z"/><path d="M9 8h6"/><path d="M9 12h6"/>',
  arrow: '<path d="M5 12h14"/><path d="M13 6l6 6-6 6"/>',
};

export default {
  name: "InvIcon",
  props: {
    name: { type: String, required: true },
  },
  computed: {
    markup() {
      return ICONS[this.name] || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.inv-icon {
  width: 1em;
  height: 1em;
  display: inline-block;
  vertical-align: middle;
}
</style>
